// Override Settings
var boostPFSFilterConfig = {
	general: {
		limit: boostPFSThemeConfig.custom.products_per_page,
		// Optional
		loadProductFirst: false,
		breakpointMobile: '319',
		defaultDisplay: boostPFSThemeConfig.custom.layout,
		collageNumber: 3,
		showPlaceholderProductList: true,
		activeLoadPreviousPage: true
	}
};


(function() {
	BoostPFS.inject(this);

	/************************** BUILD PRODUCT LIST **************************/

	// Build Product Collage Item
	ProductCollageItem.prototype.compileTemplate = function(data, index, totalProduct) {
		if (!data) data = this.data;
		if (!index) index = this.index;
		if (!totalProduct) totalProduct = this.totalProduct;
		/*** Prepare data ***/
		var images = data.images_info;
		// Displaying price base on the policy of Shopify, have to multiple by 100
		var soldOut = !data.available; // Check a product is out of stock
		var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
		var priceVaries = data.price_min != data.price_max; // Check a product has many prices
		// Get First Variant (selected_or_first_available_variant)
		var firstVariant = data['variants'][0];
		if (Utils.getParam('variant') !== null && Utils.getParam('variant') != '') {
			var paramVariant = data.variants.filter(function(e) { return e.id == Utils.getParam('variant'); });
			if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
		} else {
			for (var i = 0; i < data['variants'].length; i++) {
				if (data['variants'][i].available) {
					firstVariant = data['variants'][i];
					break;
				}
			}
		}
		/*** End Prepare data ***/

		// Get Template
		var itemHtml = boostPFSTemplate.productCollageItemHtml;

		// Wrapper for collage
		var startCollageWrapper = '';
		var endCollageWrapper = '';
		// Grid Width class
		var itemGridWidthClass = boostPFSThemeConfig.custom.grid_item_width;

		itemHtml = itemHtml.replace(/{{startCollageWrapper}}/g, startCollageWrapper);
		itemHtml = itemHtml.replace(/{{endCollageWrapper}}/g, endCollageWrapper);
		itemHtml = itemHtml.replace(/{{itemGridWidthClass}}/g, itemGridWidthClass);

		// Add soldOut class
		var soldOutClass = soldOut ? boostPFSTemplate.soldOutClass : '';
		itemHtml = itemHtml.replace(/{{soldOutClass}}/g, soldOutClass);

		// Add soldOut and onSale label
		if (soldOut) {
			itemHtml = itemHtml.replace(/{{itemSoldOutLabel}}/g, boostPFSTemplate.soldOutLabelHtml);
		} else {
			itemHtml = itemHtml.replace(/{{itemSoldOutLabel}}/g, '');
			if (onSale) {
				itemHtml = itemHtml.replace(/{{itemSaleLabel}}/g, boostPFSTemplate.saleLabelHtml.replace(/{{saleLabel}}/g, boostPFSThemeConfig.label.save_price));
				itemHtml = itemHtml.replace(/{{ saved_amount }}/g, Utils.formatMoney(data.compare_at_price_min - data.price_min, Globals.moneyFormat));
			}
		}
		itemHtml = itemHtml.replace(/{{itemSaleLabel}}/g, '');

		// Add Thumbnail
		var itemThumbUrl = images.length > 0 ? Utils.optimizeImage(images[0]['src'], 'grande') : Settings.getSettingValue('general.no_image_url');
		itemHtml = itemHtml.replace(/{{itemThumbUrl}}/g, itemThumbUrl);

		// Add Vendor
		var itemVendorHtml = boostPFSThemeConfig.custom.vendor_enable ? boostPFSTemplate.vendorHtml.replace(/{{vendor}}/g, data.vendor) : '';
		itemHtml = itemHtml.replace(/{{itemVendor}}/g, itemVendorHtml);

		// Add Price
		var itemPriceHtml = '';
		if (onSale) {
			itemPriceHtml += '<span class="visually-hidden">' + boostPFSThemeConfig.label.sale_price + '</span>';
		} else {
			itemPriceHtml += '<span class="visually-hidden">' + boostPFSThemeConfig.label.regular_price + '</span>';
		}
		if (priceVaries) {
			// itemPriceHtml += Utils.formatMoney(data.price_min, Globals.moneyFormat);
			// itemPriceHtml += '<span class="icon-fallback-text"><span class="icon icon-plus grid-product__price-min" aria-hidden="true"></span><span class="fallback-text">+</span></span>';
		} else {
			itemPriceHtml += Utils.formatMoney(data.price_min, Globals.moneyFormat);
		}
		itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);

		// Add Reviews
		if (typeof Integration !== 'undefined' && !Integration.hascompileTemplate('reviews')) {
			itemHtml = itemHtml.replace(/{{itemReviews}}/g, '');
		}

		// Add main attribute
		itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
		itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
		itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
		itemHtml = itemHtml.replace(/{{itemUrl}}/g, '/products/' + data.handle);

		return itemHtml;
	};

	// Build Product Grid Item
	ProductGridItem.prototype.compileTemplate = function(data, index) {
		if (!data) data = this.data;
		/*** Prepare data ***/
		var images = data.images_info;
		// Displaying price base on the policy of Shopify, have to multiple by 100
		var soldOut = !data.available; // Check a product is out of stock
		var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
		var priceVaries = data.price_min != data.price_max; // Check a product has many prices
		// Get First Variant (selected_or_first_available_variant)
		var firstVariant = data['variants'][0];
		// var customPrice = data.metafields
		if (Utils.getParam('variant') !== null && Utils.getParam('variant') != '') {
			var paramVariant = data.variants.filter(function(e) { return e.id == Utils.getParam('variant'); });
			if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
		} else {
			for (var i = 0; i < data['variants'].length; i++) {
				if (data['variants'][i].available) {
					firstVariant = data['variants'][i];
					break;
				}
			}
		}
		/*** End Prepare data ***/

		// Get Template
		var itemHtml = boostPFSTemplate.productGridItemHtml;

		// Add soldOut class
		var soldOutClass = soldOut ? boostPFSTemplate.soldOutClass : '';
		itemHtml = itemHtml.replace(/{{soldOutClass}}/g, soldOutClass);

		// Add soldOut and onSale label
		if (soldOut) {
			itemHtml = itemHtml.replace(/{{itemSoldOutLabel}}/g, boostPFSTemplate.soldOutLabelHtml);
		} else {
			itemHtml = itemHtml.replace(/{{itemSoldOutLabel}}/g, '');
			if (onSale) {
				itemHtml = itemHtml.replace(/{{itemSaleLabel}}/g, boostPFSTemplate.saleLabelHtml.replace(/{{saleLabel}}/g, boostPFSThemeConfig.label.save_price));
				itemHtml = itemHtml.replace(/{{ saved_amount }}/g, Utils.formatMoney(data.compare_at_price_min - data.price_min, Globals.moneyFormat));
			}
		}
		itemHtml = itemHtml.replace(/{{itemSaleLabel}}/g, '');

		// Build Image style
		var imageStyle = buildImageStyle(data);
		itemHtml = itemHtml.replace(/{{imageStyle}}/g, imageStyle);

		// Add Images
		var img_id_class = 'ProductCardImage-{{itemId}}';
		var wrapper_id = 'ProductCardImageWrapper-{{itemId}}';

		var itemImagesHtml = '';
		if (images.length > 0) {
			var aspect_ratio = images[0]['width'] / images[0]['height'];

			itemImagesHtml += '<div id="' + wrapper_id + '" class="product--wrapper mr-product--wrapper">';
			itemImagesHtml += '<div style="padding-top:' + (1 / aspect_ratio * 100) + '%;">';
			itemImagesHtml += '<a href="{{itemUrl}}"><img class="product--image mr-product--firstImage lazyload ' + (images.length == 1 ? 'no-hover' : '') +  '"' +
				' src="' + Utils.getFeaturedImage(images, '150x150') + '"' +
				' data-src="' + Utils.getFeaturedImage(images, '{width}x') + '"' +
				' data-widths="[180, 370, 590, 740, 900, 1080, 1296, 1512, 1728, 2048]"' +
				' data-aspectratio="' + aspect_ratio + '"' +
				' data-sizes="auto"' +
				' alt="{{itemTitle}}"></a>';
			itemImagesHtml += '<a href="{{itemUrl}}" class="mobile-first-image"><img class="product--image lazyload ' + '"' +
				' src="' + Utils.getFeaturedImage(images, '150x150') + '"' +
				' data-src="' + Utils.getFeaturedImage(images, '{width}x') + '"' +
				' data-widths="[180, 370, 590, 740, 900, 1080, 1296, 1512, 1728, 2048]"' +
				' data-aspectratio="' + aspect_ratio + '"' +
				' data-sizes="auto"' +
				' alt="{{itemTitle}}"></a>';
			if(images.length > 1){
				if(window.innerWidth > 768){
					images.shift();
					itemImagesHtml += '<a href="{{itemUrl}}"><img class="product--image mr-product--image mr-product--secondImage lazyload loadHidden test' + img_id_class + '"' +
					' src="' + Utils.getFeaturedImage(images, '150x150') + '"' +
					' data-src="' + Utils.getFeaturedImage(images, '{width}x') + '"' +
					' data-widths="[180, 370, 590, 740, 900, 1080, 1296, 1512, 1728, 2048]"' +
					' data-aspectratio="' + aspect_ratio + '"' +
					' data-sizes="auto"' +
					' alt="{{itemTitle}}"></a>';
				}				
			}
			
			itemImagesHtml += '</div></div>';
			itemImagesHtml += '<noscript><img class="grid-product__image" src="' + Utils.getFeaturedImage(images, '1024x') + '" alt="{itemTitle}}"></noscript>';
		} else {
			itemImagesHtml += '<img class="grid-product__image" src="' + Utils.getFeaturedImage(images, '1024x') + '" alt="{{itemTitle}}">';
		}
		itemHtml = itemHtml.replace(/{{itemImages}}/g, itemImagesHtml);

		// Add Vendor
		var itemVendorHtml = boostPFSThemeConfig.custom.vendor_enable ? boostPFSTemplate.vendorHtml.replace(/{{vendor}}/g, data.vendor) : '';
		itemHtml = itemHtml.replace(/{{itemVendor}}/g, itemVendorHtml);

		// Add Price
		var customPrice = ''
		for (var i = 0; i < data.metafields.length; i++) {
			if(typeof data.metafields[i] != 'undefined' && data.metafields[i].key == 'custom_product_link'){
				// var productsubtitle = data.metafields[i].value;
				customPrice += '<span class="custom-price">From&nbsp;</span> ';
			}
		}
		var itemPriceHtml = '';
		if (onSale) {
			itemPriceHtml += '<span class="visually-hidden">' + boostPFSThemeConfig.label.sale_price + '</span>';
			itemPriceHtml += '<div class="prod-compare-price">'+ Utils.formatMoney(data.compare_at_price_max, Globals.moneyFormat) +'</div>';

		} else {
			itemPriceHtml += '<span class="visually-hidden">' + boostPFSThemeConfig.label.regular_price + '</span>';
		}
		if (priceVaries) {
			itemPriceHtml += Utils.formatMoney(data.price_min, Globals.moneyFormat);
			// itemPriceHtml += '<span class="icon-fallback-text"><span class="icon icon-plus grid-product__price-min" aria-hidden="true"></span><span class="fallback-text">+</span></span>';
			// itemPriceHtml += '<div class="prod-compare-price">'+ Utils.formatMoney(data.price_max, Globals.moneyFormat) +'</div>';
		} else {
			itemPriceHtml += Utils.formatMoney(data.price_min, Globals.moneyFormat);
		}
		var itemPriceCurrency = boostPFSAppConfig.shop.currency;
		itemHtml = itemHtml.replace(/{{itemPriceCurrency}}/g, itemPriceCurrency);
		itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);
		itemHtml = itemHtml.replace(/{{itemCustomPrice}}/g, customPrice);

		// Add data json
		var itemJson = {
			"id": data.id,
			"title": data.title,
			"handle": data.handle,
			"vendor": data.vendor,
			"variants": data.variants,
			"url": '/products/' + data.handle,
			"options_with_values": data.options_with_values,
			"images": data.images,
			"available": data.available,
			"price_min": data.price_min,
			"price_max": data.price_max,
			"compare_at_price_min": data.compare_at_price_min,
			"compare_at_price_max": data.compare_at_price_max,
			"custom_price": data.metafields.custom_price
		};
		itemHtml = itemHtml.replace(/{{itemJson}}/g, JSON.stringify(itemJson));

		// if ( itemJson.price_min != itemJson.price_max ) {
		// 	<div class="prod-compare-price"></div>
		// }

		// Add Reviews
		if (typeof Integration === 'undefined' || !Integration.hascompileTemplate('reviews')) {
			itemHtml = itemHtml.replace(/{{itemReviews}}/g, '');
		}
		var arrayLength = data.tags.length;
		for (var i = 0; i < arrayLength; i++) {
			if(data.tags[i] == 'new'){
		    	Newlabel = data.tags[i];
		    }
		}

		// jQuery.getJSON('/admin/products/'+ data.id +'/metafields.json', function(product) {
		// 	for (var i = 0; i < product.metafields.length; i++) {
		// 		if(typeof product.metafields[i] != 'undefined' && product.metafields[i].key == 'subtitle'){
		// 			var productsubtitle = product.metafields[i].value;
		// 			$('.filter-frontpages-' + data.id).text(productsubtitle);
		// 		}
		// 	}
		// 	if(data.tags.includes("new")){
		// 		$('.item-new-label-'+data.id).html('<div class="mr-collection-productCard__badge new">' + Newlabel +'</div>');
		// 	}
		// } );

		// ===== START - Insert subtitle to product cards =====
		// fetch(`/admin/products/${data.id}/metafields.json`).then((res) => {
		// 	return res.json();
		// }).then((product) => {
		// 	for (let i = 0; i < product.metafields.length; i++) {
		// 		if (product.metafields[i].key == 'subtitle' && product.metafields[i].namespace == 'descriptors') {
		// 			const subtitle = document.querySelector(`.subtitle.filter-frontpages-${data.id}`);
		// 			subtitle.innerText = product.metafields[i].value;
		// 		};
		// 	};
		// }).catch((err) => {
		// 	console.log(err);
		// });
		// ===== END - Insert subtitle to product cards =====

      	for (var i = 0; i < data.metafields.length; i++) {
			if(typeof data.metafields[i] != 'undefined' && data.metafields[i].key == 'subtitle'){
				var productsubtitle = data.metafields[i].value;
				$('.filter-frontpages-' + data.id).text(productsubtitle);
			}
		}

		// if(data.tags.includes("new")){
		// 	setTimeout( function(){
		// 		let tagContainer = $('.item-new-label-'+data.id);
		// 		$(tagContainer).html('<div class="mr-collection-productCard__badge new">' + Newlabel +'</div>');
		// 	},1000)
			
		// }
		
		// Add main attribute
		itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
		itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
		itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
			//itemHtml = itemHtml.replace(/{{itemNew}}/g, Newlabel);
		itemHtml = itemHtml.replace(/{{itemUrl}}/g, '/products/' + data.handle);

		return itemHtml;
	};
	function buildImageStyle(data) {
		var images = data.images_info;
		var img_id_class = 'ProductCardImage-{{itemId}}';
		var wrapper_id = 'ProductCardImageWrapper-{{itemId}}';
		var imageStyle = '';
		if (images.length > 0) {
			var image = images[0];
			var width = boostPFSThemeConfig.custom.max_height;
			var height = boostPFSThemeConfig.custom.max_height;
			var small_style = true;
			var aspect_ratio = image.width / image.height;

			if (aspect_ratio <= 1) {
				var max_width = height * aspect_ratio;
				if (image.height < height) {
					var max_height = image.height;
					var max_width = image.width;
				} else {
					var max_height = height;
				}
			} else {
				var max_height = width / aspect_ratio;
				if (image.width < width) {
					var max_height = image.height;
					var max_width = image.width;
				} else {
					var max_width = width;
				}
			}

			imageStyle += '<style>';
			if (small_style) imageStyle += '@media screen and (min-width: 591px) {';
			imageStyle += '.' + img_id_class + ' {' +
				'max-width: ' + max_width + 'px;' +
				'max-height: ' + max_height + 'px;' +
				'}' +
				'#' + wrapper_id + ' {' +
				'max-width: ' + max_width + 'px;' +
				'}';
			if (small_style) imageStyle += '}';

			if (small_style) {
				if (aspect_ratio <= 1) {
					max_width = 295 * aspect_ratio;
				} else {
					if (image.width < 590) {
						max_width = image.width;
					} else {
						max_width = 590;
					}
				}
				imageStyle += '@media screen and (max-width: 590px) {'
				'.' + img_id_class + '{' +
					'max-width: {{ max_width }}px;' +
					'}' +
					'#' + wrapper_id + '{' +
					'max-width: {{ max_width }}px;' +
					'}' +
					'}';
			}
			imageStyle += '</style>';
		}
		return imageStyle;
	}



	/************************** END BUILD PRODUCT LIST **************************/


	// Build Sorting
	ProductSorting.prototype.compileTemplate = function() {
		var html = '';
		if (boostPFSTemplate.hasOwnProperty('sortingHtml')) {
			var sortingArr = Utils.getSortingList();
			if (sortingArr) {
				// Build content
				var sortingItemsHtml = '';
				for (var k in sortingArr) {
					sortingItemsHtml += '<option value="' + k + '">' + sortingArr[k] + '</option>';
				}
				html = boostPFSTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
			}
		}
		return html;
	};

	// Build Pagination
	ProductPaginationDefault.prototype.compileTemplate = function(totalProduct) {
		if (!totalProduct) totalProduct = this.totalProduct;
		// Get page info
		var currentPage = parseInt(Globals.queryParams.page);
		var totalPage = Math.ceil(totalProduct / Globals.queryParams.limit);

		if (totalPage > 1) {
			var paginationHtml = boostPFSTemplate.paginateHtml;

			// Build Previous
			var previousHtml = (currentPage > 1) ? boostPFSTemplate.previousHtml : '';
			previousHtml = previousHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage - 1));
			paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);

			// Build Next
			var nextHtml = (currentPage < totalPage) ? boostPFSTemplate.nextHtml : '';
			nextHtml = nextHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage + 1));
			paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);

			// Create page items array
			var beforeCurrentPageArr = [];
			for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
				beforeCurrentPageArr.unshift(iBefore);
			}
			if (currentPage - 4 > 0) {
				beforeCurrentPageArr.unshift('...');
			}
			if (currentPage - 4 >= 0) {
				beforeCurrentPageArr.unshift(1);
			}
			beforeCurrentPageArr.push(currentPage);

			var afterCurrentPageArr = [];
			for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
				afterCurrentPageArr.push(iAfter);
			}
			if (currentPage + 3 < totalPage) {
				afterCurrentPageArr.push('...');
			}
			if (currentPage + 3 <= totalPage) {
				afterCurrentPageArr.push(totalPage);
			}

			// Build page items
			var pageItemsHtml = '';
			var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
			for (var iPage = 0; iPage < pageArr.length; iPage++) {
				if (pageArr[iPage] == '...') {
					pageItemsHtml += boostPFSTemplate.pageItemRemainHtml;
				} else {
					pageItemsHtml += (pageArr[iPage] == currentPage) ? boostPFSTemplate.pageItemSelectedHtml : boostPFSTemplate.pageItemHtml;
				}
				pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
				pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, pageArr[iPage]));
			}
			paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);

			return paginationHtml;
		}

		return '';
	};

	ProductItem.prototype.beforeRender = function() {
		if (!this.$element && Globals.queryParams.display == ProductList.Enum.itemStyle.COLLAGE) {
			if (this.parent.isRender()) {
				// On none first load, render element from template
				this.$element = jQ(this.compileTemplate());
			} else {
				// On first load, select element from the DOM
				this.$element = this.$productList.find('.grid__item.grid-product').eq(this.index);
			}
		}
	}

	// Add additional feature for product list, used commonly in customizing product list
	ProductList.prototype.afterRender = function(data) {
		if (!data) data = this.data;

		var collageNumber = Settings.getSettingValue('general.collageNumber');
		var row = 0;
		var $products = this.$element.children('.grid__item.grid-product');

		var largeClass = $('.mr-gridView-selected').hasClass('mr-gridView-fourTwo') ? 'large--one-quarter' : 'large--one-half';
		$products.removeClass('large--one-quarter large--one-half');
		$products.addClass(`medium--one-half small--one-half column-changer ${largeClass}`);
		

		jQ(document).ready(function() {
			if (typeof theme != 'undefined' && typeof theme.Sections == 'function') {
				var boostSections = new theme.Sections();
				if (typeof boostSections.register == 'function') {
					if (Utils.isSearchPage() === true) {
						boostSections.register('search', theme.Search);
					} else {
						boostSections.register('collection-template', theme.Collection);
					}
				}
			}
		});
		var initContentBreak = () => {
			if ($(window).width() >= 769) {
				if($('.grid__item.appended-class-first').length > 0){
					$('.appended-class-first .grid__item.grid-product').insertBefore('.appended-class-first');
					$('.appended-class-first').remove();
				}
				if($('.grid__item.appended-class').length > 0){
					$('.appended-class .grid__item.grid-product').insertBefore('.appended-class');
					$('.appended-class').remove();
				}

				$('<div class="grid__item appended-class-first large--one-half"></div>').insertAfter('.grid__item.grid-product:eq(5)');
				$('<div class="grid__item appended-class large--one-half"></div>').insertAfter('.grid__item.grid-product:eq(14)');
				$('<div class="half-vert-box-top"></div>').appendTo('.appended-class-first');
				$('<div class="half-vert-box-bottom"></div>').appendTo('.appended-class-first');
				$('.grid__item.grid-product:eq(5)').appendTo('.half-vert-box-top');
				$('.grid__item.grid-product:eq(6)').appendTo('.half-vert-box-top');      
				$('.need-help-find-showroom').clone().appendTo('.half-vert-box-bottom');

				$('<div class="half-vert-box-top_2"></div>').appendTo('.appended-class');
				$('<div class="half-vert-box-bottom_2"></div>').appendTo('.appended-class');
				$('.grid__item.grid-product:eq(15)').appendTo('.half-vert-box-top_2');
				$('.grid__item.grid-product:eq(16)').appendTo('.half-vert-box-top_2');
				$('.need-help-purchase-dress').clone().appendTo('.half-vert-box-bottom_2');		
			}
		}
		// initContentBreak();

		$('.mr-gridView-fourContainer').on('click', function() {
			// initContentBreak();
		});

		/** Start Swym integration **/
		window.SwymCallbacks = window.SwymCallbacks || [];
		window.SwymCallbacks.push(function(swat) { 
			// Wrap with callback for loading without additional checks
			var products = [];
			data.forEach(function(product) {
				var image_src = Utils.getFeaturedImage(product.images_info);
				var productCopy = product;
				productCopy.featured_image = image_src;
				productCopy.price = product.price_min; // Sometimes I need to multiply the price with 100
				productCopy.compare_at_price = product.compare_at_price_min; // Sometimes I need to multiply the price with 100
				products.push(productCopy);
			});
			swat.mapShopifyProducts(products); // Product mapped data to swym layer
			swat.initializeActionButtons('.boost-pfs-filter-products'); // Buttons can now be initialized
		});
		/** End Swym integration **/
	};

	// Build additional elements
	FilterResult.prototype.afterRender = function(data, eventType) {
		if (!data) data = this.data;
		if (!eventType) eventType = this.eventType;
		if($('.collection-filter-label').hasClass('open')){
			$('.collection-filter-label').click()
		}
		$('#CollectionSection .gll-progress .collection-all-products').html(this.data.total_product);
		
		// Inject editorial banners at their respective positions
		// Remove any existing editorial banners first to prevent duplicates
		$('.boost-pfs-filter-products .editorial-banner-item').remove();
		
		// Get all editorial banners from the hidden container
		var $editorialBannersContainer = $('#editorial-banners-container');
		if ($editorialBannersContainer.length > 0) {
			var $banners = $editorialBannersContainer.find('.editorial-banner');
			
			// Get the grid classes from products to match styling
			var largeClass = $('.mr-gridView-selected').hasClass('mr-gridView-fourTwo') ? 'large--one-quarter' : 'large--one-half';
			var gridClasses = 'grid__item grid-product medium--one-half small--one-half column-changer ' + largeClass + ' editorial-banner-item';
			
			// Collect banners with their positions and sort by position (ascending)
			var bannersToInsert = [];
			$banners.each(function() {
				var $banner = $(this);
				var position = parseInt($banner.attr('data-position'), 10);
				if (!isNaN(position) && position >= 1) {
					bannersToInsert.push({
						element: $banner,
						position: position
					});
				}
			});
			
			// Sort banners by position (ascending)
			bannersToInsert.sort(function(a, b) {
				return a.position - b.position;
			});
			
			// Insert banners in sorted order (from lowest to highest position)
			// Insert AT the exact position (position 1 = grid position #1, position 20 = grid position #20)
			//
			// BANNER DISPLAY LOGIC:
			// - If banner position <= products loaded: insert at exact position
			// - If banner position > products loaded AND more products will load (infinite scroll): defer to future afterRender
			// - If banner position > products loaded AND NO more products will load (final state): append at end of grid
			//
			// Get initial count of products only (banners have already been removed above)
			var $productsOnly = $('.boost-pfs-filter-products > .grid__item').not('.editorial-banner-item');
			var totalProductsLoaded = $productsOnly.length;
			
			// Get total available products in the collection from the API response
			// This tells us the maximum number of products that could ever be loaded
			var totalAvailableProducts = data.total_product || 0;
			
			// Determine if all products have been loaded (final page state)
			// When totalProductsLoaded >= totalAvailableProducts, no more products will load via infinite scroll
			var isAllProductsLoaded = totalProductsLoaded >= totalAvailableProducts;
			
			// Track banners that should be appended at the end (position exceeds total available products)
			var bannersToAppendAtEnd = [];
			
			for (var i = 0; i < bannersToInsert.length; i++) {
				var banner = bannersToInsert[i];
				var targetPosition = banner.position; // Position is 1-indexed (1 = first position in grid)
				var targetIndex = targetPosition - 1; // Convert to 0-indexed
				
				// CASE 1: Banner position is within currently loaded products - insert at exact position
				if (targetPosition <= totalProductsLoaded) {
					// Get all current items in the grid (products + banners already inserted in this loop)
					var $allItems = $('.boost-pfs-filter-products > .grid__item');
					var $targetItem = $allItems.eq(targetIndex);
					
					// Clone the banner and wrap it with grid classes
					var $bannerClone = banner.element.clone();
					var $bannerWrapper = $('<div class="' + gridClasses + '"></div>');
					$bannerWrapper.append($bannerClone);
					
					if ($targetItem.length > 0) {
						// Insert before the item at target position (this makes banner become position #targetPosition)
						$targetItem.before($bannerWrapper);
					}
					continue;
				}
				
				// CASE 2: Banner position exceeds currently loaded products
				// Sub-case 2a: More products will load later (infinite scroll pending) - defer to future afterRender
				if (!isAllProductsLoaded && targetPosition <= totalAvailableProducts) {
					// Skip this banner - it will be inserted when more products are loaded
					continue;
				}
				
				// Sub-case 2b: No more products will load OR banner position exceeds total available products
				// This is the final state - append banner at the end of the grid
				// This handles:
				// - PLPs with fewer products than banner position (e.g., 2 products, banner position 3)
				// - Final page of infinite scroll where remaining banners should display
				bannersToAppendAtEnd.push(banner);
			}
			
			// Append banners at the end of the grid (for banners whose position exceeds available products)
			// Only do this when all products are loaded (final state) or when there are no products at all
			if (bannersToAppendAtEnd.length > 0 && (isAllProductsLoaded || totalProductsLoaded === 0)) {
				var $productGrid = $('.boost-pfs-filter-products');
				
				// Handle edge case: empty product grid
				if (totalProductsLoaded === 0 && totalAvailableProducts === 0) {
					// For empty grids, append all banners in order
					for (var j = 0; j < bannersToAppendAtEnd.length; j++) {
						var endBanner = bannersToAppendAtEnd[j];
						var $endBannerClone = endBanner.element.clone();
						var $endBannerWrapper = $('<div class="' + gridClasses + '"></div>');
						$endBannerWrapper.append($endBannerClone);
						$productGrid.append($endBannerWrapper);
					}
				} else {
					// For non-empty grids, append banners at the end
					for (var k = 0; k < bannersToAppendAtEnd.length; k++) {
						var appendBanner = bannersToAppendAtEnd[k];
						var $appendBannerClone = appendBanner.element.clone();
						var $appendBannerWrapper = $('<div class="' + gridClasses + '"></div>');
						$appendBannerWrapper.append($appendBannerClone);
						$productGrid.append($appendBannerWrapper);
					}
				}
			}
		}
	};

	// Build placeholder for Collage product
	ProductListPlaceholder.prototype.compileTemplateExtra = function(eventType) {
		var display = Globals.queryParams.display;
		var html;
		if (typeof display !== 'undefined' && display == 'collage') {
			html = boostPFSTemplate.skeletonProductCollage;
		}

		//console.log(html, 'Boost placeholder template');
		return html
			.replace(/{{class.filterProductSkeleton}}/g, Class.filterProductSkeleton)
			.replace(/{{class.filterSkeleton}}/g, Class.filterSkeleton)
			.replace(/{{class.filterSkeletonText}}/g, Class.filterSkeletonText);
	}
})();